import React, {useEffect} from "react";
import styles from "../IndexRegistration.module.scss";
import { cookieHelpers } from "helpers/cookieHelpers";

export default function Step3() {
  const handleBack = () => {
    cookieHelpers.clearAllSessionData();
    window.location.href = "/trimite-index";
  };

  useEffect(() => {
    cookieHelpers.clearAllSessionData();
  }, []);

  return (
    <section className="pb-55">
      <div className={styles.indexContainer}>
        <img src="/img/new/2025/index2.svg" alt="Index" className={styles.indexImage} />
        <p className={styles.successText}>
          Index-ul a fost inregistrat/transmis cu success. Urmeaza sa primiti un e-mail de confirmare. Iti multumim!
        </p>
        <div className={styles.successButtonContainer}>
          <button type="button" onClick={handleBack} className="btn btn-danger">
            Inapoi
          </button>
        </div>
      </div>
    </section>
  );
}
